/**
 * @generated SignedSource<<c76a8cffdc79205c16d681b5a070634c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WebFormQuestionTableFieldFragment$data = {
  readonly richEditorBody: string;
  readonly " $fragmentType": "WebFormQuestionTableFieldFragment";
};
export type WebFormQuestionTableFieldFragment$key = {
  readonly " $data"?: WebFormQuestionTableFieldFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"WebFormQuestionTableFieldFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WebFormQuestionTableFieldFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "richEditorBody",
      "storageKey": null
    }
  ],
  "type": "WebFormQuestion",
  "abstractKey": null
};

(node as any).hash = "bd5a84466e1880292f14ce3f26a026fc";

export default node;
